__turbopack_context__.v({
  "bottom": "_8m6GmW_bottom",
  "columns": "_8m6GmW_columns",
  "footer": "_8m6GmW_footer",
  "logo": "_8m6GmW_logo",
  "logoSurface": "_8m6GmW_logoSurface",
});
